import Swiper, { Scrollbar, Autoplay } from 'swiper';

export const blogGridCarousel = () => {
  const sliders = document.querySelectorAll('.blog-list-grid');

  sliders.forEach((slider) => {
    const autoplay = slider.dataset.autoplay === 'true';
    const autoplayDelay = parseInt(slider.dataset.autoplayDelay);

    const swiperOptions = {
      modules: [Scrollbar],
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        dragSize: 100,
      },
      speed: 400,
      spaceBetween: 32,
      slidesPerView: 3,
      breakpoints: {
        1200: {
          slidesPerView: 3,
          dragSize: 600,
        },
        900: {
          slidesPerView: 3,
          dragSize: 300,
          spaceBetween: 16,
        },
        600: {
          slidesPerView: 2.2,
          dragSize: 150,
          spaceBetween: 16,
        },
        320: {
          slidesPerView: 1.38,
          dragSize: 150,
          spaceBetween: 16,
        },
      },
    };

    if (autoplay) {
      swiperOptions.modules.push(Autoplay);
      swiperOptions.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false,
      };
    }

    new Swiper(slider, swiperOptions);
  });
};
